import styled, { css } from 'styled-components';
import Modal from 'react-modal';

interface ITdProps {
  heading?: string;
}

interface IMovementPriceProps {
  negative: boolean;
}

export const Container = styled.section`
  ${({ theme }) => css`
    background: ${theme.colors.background};
    border-radius: ${theme.radius.default};
    box-shadow: ${theme.shadows.flat};
    padding: 2.4rem;
    width: 100%;
    margin: 2.4rem 0;
  `}
`;

export const Table = styled.table`
  ${({ theme }) => css`
    margin: 3rem 0 0 0;
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0 4px;
    background-color: ${theme.colors.lightGrey};
    box-shadow: 1px 1px 6px #ececec;
    border-radius: ${theme.radius.small};

    > thead {
      @media (max-width: 995px) {
        display: none;
      }

      > tr > th {
        padding: 1.8rem 1rem 0 1rem;
        font-size: 14px;
        text-transform: uppercase;

        &:first-child {
          padding-left: 2rem;
        }
      }
    }

    > tbody {
      background-color: ${theme.colors.backgroundContainer};

      > tr {
        transition: all 0.25s ease;
        background-color: #fff;

        &:hover {
          transform: translateY(-1px);
          background-color: ${theme.colors.hoverTable};
          border-radius: ${theme.radius.small};
        }

        @media (max-width: 995px) {
          display: block;
          margin-bottom: 2rem;
          border-radius: ${theme.radius.small};
        }
      }
    }
  `}
`;

export const Td = styled.td<ITdProps>`
  ${({ theme, heading }) => css`
    border: 0;
    font-size: 14px;
    padding: 1rem 1rem 0.5rem 1rem;
    font-weight: ${theme.weight.default};

    &:first-child {
      padding-left: 2rem;

      &::before {
        border-top-left-radius: ${theme.radius.small};
      }
    }

    &:last-child {
      &::before {
        border-bottom-left-radius: ${theme.radius.small};
      }
    }

    @media (max-width: 995px) {
      display: block;
      position: relative;
      width: 100% !important;
      padding-left: 15.2rem;
      text-align: left !important;

      &:first-child {
        padding-left: 15.2rem;
      }

      &::before {
        ${heading &&
        css`
          content: '${heading}';
        `}

        width: 13rem;
        height: 100%;
        top: 0;
        left: 0;
        display: flex;
        align-items: center;
        position: absolute;
        background-color: ${theme.colors.lightGrey};
        padding: 0 0.8rem;
        font-size: 14px;
        font-weight: 700;
      }
    }
  `}
`;

export const ListCenterComp = styled.div`
  display: flex;
  justify-content: center;

  @media (max-width: 995px) {
    justify-content: flex-start;
  }
`;

export const MovementPrice = styled.div<IMovementPriceProps>`
  ${({ theme, negative }) => css`
    color: ${negative ? theme.colors.danger : theme.colors.labelInput};
  `}
`;

export const StyledModal = styled(Modal)`
  ${({ theme }) => css`
    width: 100%;
    max-width: 680px;
    margin-top: 20%;
    margin-left: 50%;
    transform: translate(-50%, -20%);
    background-color: ${theme.colors.background};
    box-shadow: ${theme.shadows.veryStrong};
    border-radius: ${theme.radius.meddium};
  `}
`;
